import { MemberEntitlementState } from 'yo-services/yolabs/services/poplarfrontend/member_entitlement_state_pb';
export var previewStatuses = [MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_UNSPECIFIED, MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_PREVIEW];
export var activeStatuses = [MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_ACTIVE, MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_PAST_DUE];
export var canceledStatuses = [MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_CANCELED];
export var pausedStatuses = [MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_PAUSED];
/**
 * Will be deprecated once pause v1.1 ships
 * Get the membership display status for an entitlement.
 */

export var getEntitlementStatus = function getEntitlementStatus(entitlement) {
  var entitlementState = entitlement === null || entitlement === void 0 ? void 0 : entitlement.state;
  var status = 'free';
  var limitedStates = [MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_UNSPECIFIED, MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_PREVIEW];

  if (entitlementState && !limitedStates.includes(entitlementState)) {
    var activeStates = [MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_ACTIVE];
    var pastDueStates = [MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_PAST_DUE];

    if (activeStates.includes(entitlementState)) {
      if (entitlement.expireAt) {
        status = 'active-ending';
      } else {
        status = 'active-renew';
      }
    } else if (pastDueStates.includes(entitlementState)) {
      status = 'past-due';
    }
  }

  return status;
};